module.exports = __webpack_public_path__ + "static/img/dimension.3d71aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/dimension.png
// module id = ZCdp
// module chunks = 1